import { faFloppyDisk, faPlus, faPrint, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';

class ButtonGrp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttons: props.buttons || [],
      onClickHandlers: props.onClickHandlers || {},
    };
    this.buttonConfig = {
      add: { icon: faPlus, label: 'Add' },
      update: { icon: faFloppyDisk, label: 'Update' },
      print: { icon: faPrint, label: 'Print' },
      // delete: { icon: faTrash, label: 'Delete' },
    };
  }

  render() {
    const { buttons, onClickHandlers } = this.state;

    return (
      <div className='button-grp absolute top-[-52px] right-0 flex overflow-hidden bg-white divide-x divide-[#d9d9db] rounded-lg rtl:flex-row-reverse '>
        {buttons.map((buttonKey) => {
          const button = this.buttonConfig[buttonKey];
          return (
            button && (
              <button
                key={buttonKey}
                className='px-4 py-2 font-medium text-[#181D1F] transition-colors duration-200 sm:px-6 hover:bg-gray-100'
                onClick={onClickHandlers[buttonKey]}
              >
                <FontAwesomeIcon icon={button.icon} />
              </button>
            )
          );
        })}
      </div>
    );
  }
}

export default ButtonGrp;
